import React, { useMemo } from "react";
import { useActiveHeadingId } from "@/hooks/useActiveHeadingId";
import type { MarkdownHeading } from "@/lib/MarkdownHeadings";

export interface ArticleTableOfContentsProps {
  headings: readonly MarkdownHeading[];
}

export const ArticleTableOfContents: React.FC<ArticleTableOfContentsProps> = ({
  headings,
}) => {
  const headingIds = useMemo(
    () => headings.map((heading) => heading.id),
    [headings],
  );
  const activeId = useActiveHeadingId(headingIds);

  if (headings.length === 0) {
    return null;
  }

  return (
    <nav
      aria-label="目次"
      className="rounded-2xl border border-primary-100 bg-white p-4 shadow-sm"
    >
      <p className="text-xs font-bold tracking-wide text-primary-400">目次</p>
      <ul className="mt-2 space-y-0.5 border-l border-primary-100">
        {headings.map((heading) => {
          const isActive = heading.id === activeId;
          const level =
            heading.level === 3
              ? "pl-6 text-xs leading-5 text-primary-400 hover:text-primary-600"
              : "pl-3 text-[13px] leading-6 text-primary-500 hover:text-primary-700";
          const state = isActive
            ? "border-primary-400 font-semibold text-primary-700"
            : "border-transparent";

          return (
            <li key={heading.id}>
              <a
                href={`#${heading.id}`}
                aria-current={isActive ? "true" : undefined}
                className={`-ml-px block border-l-2 py-0.5 ${level} ${state}`}
              >
                {heading.text}
              </a>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};
